import React from 'react';
import { Label } from '@shared/components/ui/shadcn/label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@shared/components/ui/shadcn/select';
import { Check, Loader2 } from 'lucide-react';
import { CourierOption } from '../../models';

interface CourierSelectorProps {
    couriers: CourierOption[];
    selectedCourierId: number | null;
    onSelect: (courierId: number | null) => void;
    isLoading?: boolean;
    disabled?: boolean;
}

export const CourierSelector: React.FC<CourierSelectorProps> = ({
    couriers,
    selectedCourierId,
    onSelect,
    isLoading = false,
    disabled = false,
}) => {
    const handleValueChange = (value: string) => {
        onSelect(value ? parseInt(value, 10) : null);
    };

    return (
        <div className="bg-background border border-border rounded-lg p-4">
            <Label htmlFor="courier-select" className="block text-sm font-medium text-foreground mb-2">
                Selecciona el Courier
            </Label>
            
            <Select
                value={selectedCourierId?.toString() ?? ''}
                onValueChange={handleValueChange}
                disabled={disabled || isLoading}
            >
                <SelectTrigger id="courier-select" className="w-full h-12 text-base">
                    {isLoading ? (
                        <div className="flex items-center gap-2">
                            <Loader2 className="h-4 w-4 animate-spin" />
                            <span>Cargando couriers...</span>
                        </div>
                    ) : (
                        <SelectValue placeholder="Selecciona un courier" />
                    )}
                </SelectTrigger>
                <SelectContent>
                    {couriers.map((courier) => (
                        <SelectItem key={courier.id} value={courier.id.toString()}>
                            {courier.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            {selectedCourierId && (
                <p className="mt-2 text-sm text-green-600 dark:text-green-400 flex items-center">
                    <Check className="w-4 h-4 mr-1" />
                    Courier seleccionado. Ahora puedes escanear pedidos.
                </p>
            )}
        </div>
    );
};
